import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const SectionService = {
  // Define your API functions here
  getList: async () => {
    const response = await apiService.get("/sections");
    return response.data;
  },
  create: async (postData) => {
    const response = await apiService.post("/sections", postData);
    return response.data;
  },

  detail: async (id) => {
    const response = await apiService.get(`/sections/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/sections/${id}`);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/sections/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
};

export default SectionService;
